/**
 * PipelineSection - Reusable Component for Pipeline Cards
 *
 * Displays a list of pipeline rows with section (reports) icon; dashboard is global in project header.
 *
 * Props:
 * - pipelines: Array of pipeline objects
 * - isLoading: Boolean indicating loading state
 * - onPipelineSelect: Callback when section/reports is clicked (opens full section report)
 */

import React from 'react';
import { Spinner } from '@crc-evans/ui-components';
import { BarChart2, ChevronRight } from 'lucide-react';
import './PipelineSection.css';

const PipelineSection = ({ pipelines = [], isLoading = false, onPipelineSelect }) => {
  if (isLoading) {
    return (
      <div className="pipeline-section">
        <div className="pipeline-section-loading">
          <Spinner variant="inline" size="medium" />
          <span>Loading pipelines...</span>
        </div>
      </div>
    );
  }

  if (pipelines.length === 0) {
    return (
      <div className="pipeline-section">
        <div className="pipeline-section-empty">
          <p>No pipeline sections found.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="pipeline-section">
      <div className="pipeline-section-list">
        {pipelines.map((pipeline) => (
          <div key={pipeline.id} className="pipeline-section-row">
            <div
              className="pipeline-section-row-main"
              onClick={() => onPipelineSelect && onPipelineSelect(pipeline)}
            >
              <span className="pipeline-section-row-title">
                {pipeline.pipelineSection || pipeline.name || `Pipeline ${pipeline.id}`}
              </span>
              <div className="pipeline-section-row-actions">
                <button
                  type="button"
                  className="pipeline-section-row-icon-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    onPipelineSelect && onPipelineSelect(pipeline);
                  }}
                  title="Section Report"
                  aria-label="Section Report"
                >
                  <BarChart2 size={20} />
                </button>
                <ChevronRight size={20} className="pipeline-section-row-chevron" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PipelineSection;
